'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Functions = require('../core/Functions');

var _Small = require('../elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UIMedia = require('../layout/UIMedia');

var _UIMedia2 = _interopRequireDefault(_UIMedia);

var _UIMediaBody = require('../layout/UIMediaBody');

var _UIMediaBody2 = _interopRequireDefault(_UIMediaBody);

var _UIMediaLeft = require('../layout/UIMediaLeft');

var _UIMediaLeft2 = _interopRequireDefault(_UIMediaLeft);

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _customRenderer = require('../utils/propTypes/customRenderer');

var customRenderer = _interopRequireWildcard(_customRenderer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  default: '',
  processing: 'private-attachment--processing'
};

var SIZE_CLASSES = {
  small: 'private-attachment--small',
  large: 'private-attachment--large'
};

var DefaultFilePreview = function DefaultFilePreview(_ref) {
  var fileType = _ref.fileType;
  return _react2.default.createElement(_UIIcon2.default, {
    className: 'align-self-end',
    name: fileType === 'application/pdf' ? 'pdfFile' : 'file'
  });
};
DefaultFilePreview.propTypes = {
  fileType: _react.PropTypes.string
};

exports.default = _react2.default.createClass({
  displayName: 'UIFileAttachment',

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    closeable: _react.PropTypes.bool.isRequired,
    onCloseClick: _react.PropTypes.func,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
    size: _react.PropTypes.oneOf(Object.keys(SIZE_CLASSES)),
    fileName: _react.PropTypes.node.isRequired,
    fileInfo: _react.PropTypes.node,
    fileType: _react.PropTypes.string,
    renderPreview: customRenderer.propType
  },

  getDefaultProps: function getDefaultProps() {
    return {
      closeable: false,
      use: 'default',
      size: 'large',
      renderPreview: DefaultFilePreview
    };
  },
  getClassName: function getClassName(_ref2) {
    var className = _ref2.className,
        use = _ref2.use,
        size = _ref2.size;

    return (0, _classNames2.default)('private-attachment', className, USE_CLASSES[use], SIZE_CLASSES[size]);
  },
  handleCloseClick: function handleCloseClick(evt) {
    var onCloseClick = this.props.onCloseClick;

    (0, _Functions.callIfPossible)(onCloseClick, evt);
  },
  renderCloseButton: function renderCloseButton(_ref3) {
    var closeable = _ref3.closeable;

    if (closeable) {
      return _react2.default.createElement(_UICloseButton2.default, {
        className: 'private-attachment__close',
        onClick: this.handleCloseClick,
        size: 'small'
      });
    }

    return null;
  },
  renderFileInfo: function renderFileInfo(_ref4) {
    var fileInfo = _ref4.fileInfo,
        size = _ref4.size;

    if (fileInfo) {
      return _react2.default.createElement(
        _Small2.default,
        { className: 'private-attachment__file-info', use: 'help' },
        size === 'small' && '(',
        fileInfo,
        size === 'small' && ')'
      );
    }

    return null;
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        closeable = _props.closeable,
        use = _props.use,
        size = _props.size,
        children = _props.children,
        renderPreview = _props.renderPreview,
        fileName = _props.fileName,
        fileInfo = _props.fileInfo,
        __fileType = _props.fileType,
        __onCloseClick = _props.onCloseClick,
        rest = _objectWithoutProperties(_props, ['className', 'closeable', 'use', 'size', 'children', 'renderPreview', 'fileName', 'fileInfo', 'fileType', 'onCloseClick']);

    var renderedCloseButton = this.renderCloseButton({ closeable: closeable });
    var renderedPreview = customRenderer.render(renderPreview, this.props, {
      mergeType: 'none'
    });
    var renderedFileInfo = this.renderFileInfo({ size: size, fileInfo: fileInfo });

    return _react2.default.createElement(
      'div',
      _extends({}, rest, { className: this.getClassName({ className: className, size: size, use: use }) }),
      children && _react2.default.createElement(
        'div',
        { className: 'private-attachment__children' },
        children
      ),
      _react2.default.createElement(
        _UIMedia2.default,
        { className: 'private-attachment__media' },
        _react2.default.createElement(
          _UIMediaLeft2.default,
          { className: 'private-attachment__preview' },
          renderedPreview
        ),
        _react2.default.createElement(
          _UIMediaBody2.default,
          { className: 'private-attachment__info' },
          size === 'small' ? _react2.default.createElement(
            _UITruncateString2.default,
            { useFlex: true, fixedChildren: renderedFileInfo },
            fileName
          ) : _react2.default.createElement(
            _UITruncateString2.default,
            { useFlex: true },
            fileName
          ),
          size !== 'small' && renderedFileInfo
        )
      ),
      renderedCloseButton
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/attachment/UIFileAttachment.js
// module id = 547
// module chunks = 2 3